import * as React from 'react'
import classnames from 'classnames'

import styles from '../styles.module.scss'
import { useField } from 'formik'

export const Textarea: React.FC<React.HTMLProps<HTMLTextAreaElement>> = ({
  className,
  ...rest
}) => {
  const [, meta] = useField(rest.name)
  const inputClassName = classnames(styles.input, className, {
    [styles.inputError]: meta.error && meta.touched,
  })

  return <textarea className={inputClassName} {...rest}></textarea>
}
